import { ImageHelper } from "../../helpers/ImageHeper"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['cameraSelect', 'image']

  connect() {
    this.loadLiveImage()
  }

  loadLiveImage = (e) => {
    const self = this;

    const onImageLoad = (base64, data) => {
      self.imageTarget.src = base64
      self.dispatch('imageLoaded')
    }

    const onImageError = () => {
      self.dispatch('imageError')
    }

    ImageHelper.fetchLiveImage(this.cameraSelectTarget.value, this.imageTarget, { onLoad: onImageLoad, onError: onImageError })
  }
}
